import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ParseService } from '../../../../shared/common/parse/parse.service';
import { Router } from '@angular/router';
import { QueryInterface } from '../../../../shared/common/parse/query-interface';
import { Location } from '@angular/common';
import { LazyLoadEvent } from 'primeng/primeng';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { SocketService } from 'app/shared/common/helper/socket.service';
import { RegisterComponent } from '../../authentication/register/register.component';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../../scrumboard/excel.service';

@Component({
  selector: 'app-employees-details',
  templateUrl: './employees-details.component.html',
  styleUrls: ['./employees-details.component.scss'],
  animations: fuseAnimations
})
export class EmployeesDetailsComponent implements OnInit {
  // nameFilter: string = '';

  profileInfo: any = [];
  profileValue: any;
  yearFilter: number;
  firstname: String;
  lastname: String;
  userId = this.parseService.instance.User.current().id;
  rowData = [];
  value: any;
  totalRecords: any = 0;
  loading: boolean;
  loadEventData: LazyLoadEvent;
  yearTimeout: any;
  cols: any[];
  roleDD = [];
  report: any;
  reportingList = [];
  reportingToDD = [];
  rollOptions: SelectItem[];
  deptDD = [];
  bloodGroup = [];
  deptOptions: SelectItem[];
  bloodGroupOptions: SelectItem[];
  locationDD = [];
  locationOptions: SelectItem[];
  reportingToOptions: SelectItem[];
  selectRoll: string[];
  selectBloodGroup: string[];
  selectReporting: string[];
  selectLocation: string[];
  selectDepartment: string[];
  profileId = '';
  empRole = '';
  tabIndex = 0;
  selectRoll1: string[];
  selectBloodGroup1: string[];
  selectReporting1: string[];
  selectLocation1: string[];
  selectDepartment1: string[];
  selectRollLongLeave: string[];
  selectBloodGroupLongLeave: string[];
  selectReportingLongLeave: string[];
  selectLocationLongLeave: string[];
  selectDepartmentLongLeave: string[];
  customRoles = [];
  employeesList: string;
  experienceTableLocations: SelectItem[];
  experienceTableDesignations: SelectItem[];
  reportingOptions: SelectItem[];
  tenantId: any;
  tenantRole: any;
  tenantDepartment: any;
  createEmployeeLimit: any;
  first: any = 0;
  ManagementList: any = [];
  isManagementView: boolean = false;

  constructor(
    public dialog: MatDialog,
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private _location: Location,
    private storageConfiguration: StorageConfiguration,
    private router: Router,
    private hardCodedValues: HardCodedValues,
    private spinner: NgxSpinnerService,
    private getReportingToService: GetReportingToService,
    private _socket: SocketService,
    private toastr: ToastrService,
    private excelService: ExcelService
  ) {
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getProfileDetails();

    this.cols = [
      { field: 'position', header: 'S.No' },
      { field: 'profileImageInfo', header: 'Profile' },
      { field: 'userName', header: 'Name' },
      { field: 'desktop', header: 'Desktop' },
      { field: 'action', header: 'Action' },
      { field: 'designation', header: 'Designation' },
      { field: 'reportingTo', header: 'Reporting To' },
      { field: 'department', header: 'Department' },
      { field: 'location', header: 'Location' },
      { field: 'officialEmail', header: 'Email' },
      // { field: 'bloodGroup', header: 'Blood Group' }
    ];
    this.getEmployeesCreateLimit();

  }
  // applyNameFilter() {   
  //   // Convert the search query to lowercase for case-insensitive search
  //   const searchQuery = this.nameFilter.toLowerCase().trim();
  //   // Filter the data based on the lowercase search query
  //   this.rowData = this.profileInfo.filter(employee => {
  //     // Convert the name to lowercase for case-insensitive comparison
  //     const employeeName = employee.userName.toLowerCase();
  //     // Check if the lowercase name contains the lowercase search query
  //     return employeeName.includes(searchQuery);
  //   });   
  // }

  ngOnInit() {
    // this.getBloodGroup();
    this.getManagementList();
    this.getLocation();
    this.getDepartment();
    this.getTenantDepartment();
    this.getTenantRole();
    this.getRollOption();
    this.getReportingTo();
    // this.getEmployees();

    let currentPage: number = +localStorage.getItem('currentEmployeeDetailsPage');
    this.first = currentPage ? currentPage : 0;

    let selectedReportingList = localStorage["reportingTo"] ? JSON.parse(localStorage["reportingTo"]) : '';
    if (selectedReportingList.length > 0) {
      this.selectReporting = selectedReportingList;
    }

    let filter = JSON.parse(localStorage.getItem('employeesTable'));
    if (filter != null) {
      if (filter.filters['department'] != undefined) {
        this.selectDepartment = filter.filters['department'].value;
      }
      if (filter.filters['reportingTo'] != undefined) {
        this.selectReporting = filter.filters['reportingTo'].value;
      }
      if (filter.filters['location'] != undefined) {
        this.selectLocation = filter.filters['location'].value;
      }
      if (filter.filters['role'] != undefined) {
        this.selectRoll = filter.filters['role'].value;
      }
      if (filter.filters['personalInfo.bloodGroup'] != undefined) {
        this.selectBloodGroup = filter.filters['personalInfo.bloodGroup'].value;
      }
    }
  }

  async getManagementList() {
    const queryInstance = this.parseService.instance.Object.extend('managementEmployee');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('isActive', true);
    query.find().then(result => {
      this.ManagementList = [];
      if (result.length > 0) {
        for (let data of result) {
          this.ManagementList.push(data.get('role').id)
        }
      }
    })
  }

  /*
  ** ==========================================================
  **  Get Roll Details
  ** ==========================================================
  */
  getRollOption() {
    let result = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        if (roleList.displayName) {
          result.push({ name: roleList.displayName, id: roleList.role.objectId });
        }
        else {
          result.push({ name: roleList.name, id: roleList.objectId });
        }
      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
      this.experienceTableDesignations = this.bindExperienceDropDown(this.roleDD);
    });
  }

  /*
  ** ==========================================================
  ** Getting Reporting To Details
  ** ==========================================================
  */
  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  /*
  ** ==========================================================
  ** Getting Blood Group Details
  ** ==========================================================
  */
  async getBloodGroup() {
    let bloodGroupList = []
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let results = await query.find();
    let result = results[0];
    let bloodGroup = result.get('bloodGroup')
    bloodGroup.forEach(element => {
      bloodGroupList.push(element.value)
    });
    this.bloodGroup = bloodGroupList;
    this.bloodGroupOptions = this.bindBloodGroupDD(this.bloodGroup)
  }

  /*
  ** ==========================================================
  ** Getting Department Details
  ** ==========================================================
  */
  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = res;
    });
  }

  /*
  ** ==========================================================
  ** Getting Office Locations
  ** ==========================================================
  */
  async getLocation() {
    await this.getReportingToService.getLocation().then(res => {
      this.locationOptions = res;
      this.experienceTableLocations = this.bindExperienceDropDown(this.locationOptions);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  bindExperienceDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.label, value: a.label });
    });
    return dropDownItem;
  }

  bindBloodGroupDD(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a, value: a });
    });
    return dropDownItem;
  }

  /*
  ** ==========================================================
  **  Get Employees Function
  ** ==========================================================
  */
  async getEmployees() {
    let condition = [];
    const queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    await query.find().then(res => {
      let roleDetail = res[0];
      this.customRoles = roleDetail.get('customRoles');
      let employeesdata = this.customRoles[0];
      var keys = Object.keys(employeesdata);
      var filtered = keys.filter(function (key) {
        if (typeof employeesdata[key] != 'string') {
          return employeesdata[key]
        }
      });
      this.employeesList = filtered[0];
    });

    // if (this.employeesList == 'All') {
    //   condition = [
    //     { condition: 'equalTo', field: 'isActive', value: true },
    //     { condition: 'equalTo', field: 'isLongLeave', value: false },
    //     { condition: 'include', value: 'location' },
    //     { condition: 'include', value: 'reportingTo' },
    //     { condition: 'include', value: 'department' },
    //     { condition: 'include', value: 'role' },
    //     { condition: 'ascending', value: 'firstName' },
    //     { condition: 'equalTo', field: 'tenantId', value: this.tenantId }
    //   ];
    // }
    // else if (this.employeesList == 'Assigned') {
    //   condition = [
    //     { condition: 'equalTo', field: 'isActive', value: true },
    //     { condition: 'equalTo', field: 'isLongLeave', value: false },
    //     { condition: 'include', value: 'reportingTo' },
    //     { condition: 'include', value: 'department' },
    //     { condition: 'include', value: 'role' },
    //     { condition: 'ascending', value: 'firstName' },
    //     { condition: 'limit', value: 10 },
    //     { condition: 'equalTo', field: 'reportingTo', value: { __type: 'Pointer', className: 'Profile', objectId: this.profileId } },
    //     { condition: 'equalTo', field: 'tenantId', value: this.tenantId }
    //   ];
    // }

    // if (this.empRole == 'Leader') {
    //   condition.push({
    //     condition: 'equalTo', field: 'profile',
    //     value: {
    //       __type: 'Pointer',
    //       className: 'Profile',
    //       objectId: this.profileId
    //     }
    //   });
    // }
    this.spinner.show();
    await this.getProfileInformation(this.employeesList);
    // this.totalRecords = await this.getResourcesCount();
    // this.queryInterface.executeQuery(this.parseService, 'Profile', condition).then(async results => {
    // this.rowData = await this.loadResources(results, 0);
    //   this.spinner.hide();
    // }).catch(error => {
    //   this.spinner.hide();
    // });
  }


  async getProfileInformation(assignType) {
    let queryInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(queryInstance);

    if (assignType == 'All') {
      query.equalTo('isActive', true);
      query.equalTo('isLongLeave', false);
      query.equalTo('tenantId', this.tenantId);
      query.include('reportingTo');
      query.include('location');
      query.include('department');
      query.include('role');
      query.ascending('firstName');
      query.limit(10);
      query.withCount();
    }
    else if (assignType == 'Assigned') {
      query.equalTo('isActive', true);
      query.equalTo('isLongLeave', false);
      query.equalTo('tenantId', this.tenantId);
      query.include('reportingTo');
      query.include('location');
      query.include('department');
      query.include('role');
      query.ascending('firstName');
      query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
      query.limit(10);
      query.withCount();
    }

    await query.find().then(async result => {
      this.totalRecords = result.count
      this.rowData = await this.loadResources(result.results, 0);
      this.spinner.hide();
    }).catch(error => {
      this.spinner.hide();
    });
  }


  /*
  ** ==========================================================
  ** Lazy load
  ** ==========================================================
  */
  async onLazyLoadResources(event?: LazyLoadEvent) {
    const queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    await query.find().then(res => {
      let roleDetail = res[0];
      this.customRoles = roleDetail.get('customRoles');
      let employeesdata = this.customRoles[0];
      var keys = Object.keys(employeesdata);
      var filtered = keys.filter(function (key) {
        if (typeof employeesdata[key] != 'string') {
          return employeesdata[key]
        }
      });
      this.employeesList = filtered[0];
    });

    if (!event) {
      var event: LazyLoadEvent = {
        first: 0, // Provide appropriate values for your use case
        rows: 10,
        sortField: 'someField',
        sortOrder: 1,
        filters: {},
      };
    }

    this.loadEventData = event;
    let condition = [];

    if (this.employeesList == 'All') {
      condition = [
        { condition: 'equalTo', field: 'isActive', value: true },
        { condition: 'equalTo', field: 'isLongLeave', value: false },
        { condition: 'include', value: 'location' },
        { condition: 'include', value: 'reportingTo' },
        { condition: 'include', value: 'department' },
        { condition: 'include', value: 'role' },
        { condition: 'ascending', value: 'firstName' },
        { condition: 'equalTo', field: 'tenantId', value: this.tenantId }
      ];
      if (this.isManagementView) condition.push({ condition: 'containedIn', field: 'role', value: this.ManagementList });
      else condition.push({ condition: 'notContainedIn', field: 'role', value: this.ManagementList });
    } else if (this.employeesList == 'Assigned') {
      condition = [
        { condition: 'equalTo', field: 'isActive', value: true },
        { condition: 'equalTo', field: 'isLongLeave', value: false },
        { condition: 'include', value: 'location' },
        { condition: 'include', value: 'reportingTo' },
        { condition: 'include', value: 'department' },
        { condition: 'include', value: 'role' },
        { condition: 'ascending', value: 'firstName' },
        { condition: 'equalTo', field: 'reportingTo', value: { __type: 'Pointer', className: 'Profile', objectId: this.profileId } },
        { condition: 'equalTo', field: 'tenantId', value: this.tenantId }
      ];
      if (this.isManagementView) condition.push({ condition: 'containedIn', field: 'role', value: this.ManagementList });
      else condition.push({ condition: 'notContainedIn', field: 'role', value: this.ManagementList });
    }

    if (this.tabIndex === 1) {
      condition.push({ condition: 'descending', field: 'updatedAt' })
    }
    // if (this.empRole == 'Leader') {
    //   condition.push({
    //     condition: 'equalTo', field: 'reportingTo',
    //     value: {
    //       __type: 'Pointer',
    //       className: 'Profile',
    //       objectId: this.profileId
    //     }
    //   });
    // }
    if (this.employeesList == 'All' || this.employeesList == 'Assigned') {

      const filter: any = event.filters;
      if (!filter) {
        const skip: number = event.first;

        this.totalRecords = await this.getTotalRecordsCount(condition);
        this.lazyLoadAddResources(condition, skip, event.rows);

      } else if (event.sortField) {
        const skip: number = event.first;

        let field = event.sortField;
        let sortOrder = event.sortOrder == 1 ? 'descending' : 'ascending';
        // tslint:disable-next-line:forin
        for (let key in filter) {
          let query = filter[key].value;
          if (key == 'reportingTo' || key == 'role' || key == 'location' || key == 'department') {
            condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
          } else {
            let filterValue = filter[key].value;
            if (key != 'officialInfo.officialEmail') {
              filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            }
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }
        let sortCondition = {};
        if (sortOrder == 'ascending') {
          sortCondition = { condition: sortOrder, value: field };
        } else {
          sortCondition = { condition: sortOrder, field: field };
        }
        this.totalRecords = await this.getTotalRecordsCount(condition);
        if (this.totalRecords < event.first) {
          event.first = 0;
        }
        condition.push(sortCondition);
        this.lazyLoadAddResources(condition, skip, event.rows);
      } else {
        // tslint:disable-next-line:forin
        for (let key in filter) {
          let query = filter[key].value;
          key = key == 'bloodGroup' ? 'personalInfo.bloodGroup' : key;
          if (key == 'reportingTo' || key == 'role' || key == 'location' || key == 'department' || key == 'personalInfo.bloodGroup') {
            condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
          } else {
            let filterValue = filter[key].value;

            if (key != 'officialInfo.officialEmail') {
              filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            }
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }

        this.totalRecords = await this.getTotalRecordsCount(condition);
        if (this.totalRecords < event.first) {
          event.first = 0;
        }
        if (this.employeesList == 'All' || this.employeesList == 'Assigned') {

          this.lazyLoadAddResources(condition, event.first, event.rows);
        }
      }
    }

  }

  lazyLoadAddResources(condition, skip, limit) {
    this.spinner.show();
    let rep: any = this.selectReporting ? this.selectReporting.length : [];
    if (rep > 0) { condition.push({ condition: 'containedIn', field: 'reportingTo', value: this.selectReporting }) }
    condition.push(
      { condition: 'skip', value: skip ? skip : 0 },
      { condition: 'limit', value: limit ? limit : 10 }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId });
    this.queryInterface.executeQuery(this.parseService, 'Profile', condition).then(async results => {
      this.rowData = await this.loadResources(results, skip);
      if (rep > 0) {
        let queryInstances = this.parseService.instance.Object.extend('Profile');
        let query = new this.parseService.instance.Query(queryInstances);
        query.containedIn('reportingTo', this.selectReporting);
        query.equalTo('isActive', true);
        let user = await query.find();
        this.totalRecords = user.length
      }
      this.spinner.hide();
    });
  }

  /*
  ** ==========================================================
  ** Employees Details
  ** ==========================================================
  */
  async loadResources(results, skip) {
    let i = skip;
    let result = [];
    localStorage.setItem('currentEmployeeDetailsPage', String(skip));

    for (const element of results) {
      i = i + 1;
      let rolePoint = element.get('role');
      let locationPoint = element.get('location');
      let reportingPoint = element.get('reportingTo');
      let officialInfo = element.get('officialInfo');
      let departmentPoint = element.get('department');

      let personalInfo = element.get('personalInfo');
      let profile = element.get('profileImageInfo');
      result.push({
        position: i,
        userName: element.get('firstName') + ' ' + element.get('lastName'),
        officialEmail: officialInfo.officialEmail,
        designation: this.getReportingToService.getRoleDisplayName(rolePoint.get('name')),
        department: this.getReportingToService.getDepartmentDisplayName(departmentPoint.get('name')),
        location: locationPoint ? locationPoint.get('name') : '',
        reportingTo: reportingPoint.get('username'),
        bloodGroup: personalInfo.bloodGroup,
        profileImageInfo: profile.url,
        objectId: element.id,
        isWebDesktop: element.get('isWebDesktop') ? true : false,
        action: '',
        esslEmployeeCode: element.get('esslEmployeeCode'),
        esslEmployeeId: element.get('esslEmployeeId'),
        officeInTime: element.get('officialInfo').startTime
      });
    }
    return result;
  }

  async getTenantRole(): Promise<void> {
    this.tenantRole = await this.getReportingToService.getTenantRole(this.tenantId);
  }

  async getTenantDepartment(): Promise<void> {
    this.tenantDepartment = await this.getReportingToService.getTenantDepartment(this.tenantId);
  }

  /*
  ** ==========================================================
  ** Get total records
  ** ==========================================================
  */
  async getResourcesCount() {
    return this.queryInterface.getQueryCount(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'isLongLeave', value: false },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'limit', value: 10 },
    ]);
  }

  getTotalRecordsCount(condition) {
    return this.queryInterface.getQueryCount(this.parseService, 'Profile', condition);
  }

  viewProfile(events) {
    this.router.navigate(['profile-view', { id: events }]);
  }

  async viewTimesheet(events): Promise<void> {
    this.router.navigate(['timesheet-view', { id: events }]);
    if (this.profileId != events) {
      this._socket.sendTimesheetNotification(events, 'Timesheet');
    }
  }

  viewDashboard(events): void {
    this.router.navigate(['employees-dashboard', { id: events }]);
  }

  yearlyReport(events): void {
    this.router.navigate(['yearly-dashboard', { id: events }]);
  }

  backlocation() {
    this._location.back();
  }

  // * Get maximum user count form customer onboarding (if it is non-zero we can to create a employee with in the count)
  async getEmployeesCreateLimit(): Promise<void> {
    const CustomerOnBoarding = this.parseService.instance.Object.extend('CustomerOnBoarding');
    const customerOnBoardingQuery = new this.parseService.instance.Query(CustomerOnBoarding);
    customerOnBoardingQuery.equalTo('tenantId', this.tenantId);
    let CustomerOnBoardingResult = await customerOnBoardingQuery.find();
    CustomerOnBoardingResult = CustomerOnBoardingResult[0];
    const limitCount = CustomerOnBoardingResult.get('limitedEmployeesCount');
    if (limitCount) {
      this.createEmployeeLimit = +CustomerOnBoardingResult.get('limitedEmployeesCount');
    }
  }

  registerEmployeeDialog(): void {
    if (this.createEmployeeLimit && this.totalRecords >= this.createEmployeeLimit) {
      this.toastr.error('Maximum User Exceeded.');
      return;
    }
    const dialogRef = this.dialog.open(RegisterComponent, {
      width: '700px',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.saved) {
        this.getEmployees();
      }
    });
  }

  reportingTo(event: any) {
    localStorage["reportingTo"] = JSON.stringify(this.selectReporting);
  }


  async getProfileDetails() {

    let queryInst = this.parseService.instance.Object.extend('Profile');
    let qur = new this.parseService.instance.Query(queryInst);
    qur.equalTo('isActive', true);
    qur.equalTo('isLongLeave', false);
    qur.equalTo('tenantId', this.tenantId);
    qur.include('reportingTo');
    qur.include('department');
    qur.include('role');
    qur.ascending('firstName');
    qur.limit(10000);
    let results = await qur.find();


    for (const element of results) {
      let rolePoint = element.get('role');
      let locationPoint = element.get('location');
      let reportingPoint = element.get('reportingTo');
      let officialInfo = element.get('officialInfo');
      let departmentPoint = element.get('department');

      let personalInfo = element.get('personalInfo');
      let profile = element.get('profileImageInfo');
      this.profileInfo.push({
        userName: element.get('firstName') + ' ' + element.get('lastName'),
        officialEmail: officialInfo.officialEmail,
        designation: this.getReportingToService.getRoleDisplayName(rolePoint.get('name')),
        department: this.getReportingToService.getDepartmentDisplayName(departmentPoint.get('name')),
        location: locationPoint ? locationPoint.get('name') : '',
        reportingTo: reportingPoint.get('username'),
        bloodGroup: personalInfo.bloodGroup,
        profileImageInfo: profile.url,
        objectId: element.id,
        isWebDesktop: element.get('isWebDesktop') ? true : false,
        action: '',
        esslEmployeeCode: element.get('esslEmployeeCode'),
        esslEmployeeId: element.get('esslEmployeeId'),
        officeInTime: element.get('officialInfo').startTime,
        MeetingEnable: element.get('isMeeting')
      });
    }
  }

  exportToExcel() {
    this.excelService.exportAsExcelFile(this.profileInfo, 'Employees List');
  }

}



export interface SelectItem {
  label?: string;
  value: any;
  styleClass?: string;
  icon?: string;
  title?: string;
  disabled?: boolean;
}
